/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;
    let person = this.modelFor('people.person').person;
    let pageModel = this.modelFor('people.person.page');
    let assessments = pageModel.page.assessment_ids;
    let promises = {
      person,
      page: pageModel.page,
    };
    if (assessments.length > 0) {
      // assessments is a fragment array: spread it, or stringify reaches the store.
      let assessmentIds = JSON.stringify([...assessments]);
      promises = {
        person,
        page: pageModel.page,
        assessments: store.query('assessments/assessment', { assessmentIds }),
        modules: store.query('assessments/module', {
          assessmentIds,
          include: 'gradeSchedules',
        }),
        grades: store.query('assessments/grade', {
          assessmentIds,
          personId: person.id,
        }),
      };
    }

    return hash(promises);
  }
}
